/**
 * Test Variable Extraction
 * Utility to test the fixed variable extraction system
 */

import { PromptDataAdapter } from '../services/promptDataAdapter';

export function testVariableExtraction() {
  // Test with real CSV data format
  const testPromptContent = `Design {{PROGRAM_TYPE}} management framework for {{ORGANIZATION_NAME}} serving {{PARTICIPANT_COUNT}} {{BENEFICIARY_TYPE}} with {{RESOURCE_ALLOCATION}} budget.

Requirements:
- Create comprehensive program structure
- Include {{PRIMARY_CONSTRAINTS}} considerations  
- Develop {{STAKEHOLDER_NEEDS}} assessment framework
- Align with {{MISSION_STATEMENT}}
- Account for {{VOLUNTEER_CAPACITY}} and staff availability`;

  console.log('\n=== TESTING VARIABLE EXTRACTION ===');
  console.log('Test content:', testPromptContent.substring(0, 100) + '...');
  
  const extractedVariables = PromptDataAdapter.extractVariablesFromContent(testPromptContent);
  
  console.log('\n=== EXTRACTED VARIABLES ===');
  extractedVariables.forEach((variable, index) => {
    console.log(`${index + 1}. ${variable.name}`);
    console.log(`   Label: "${variable.label}"`);
    console.log(`   Type: ${variable.type}`);
    console.log(`   Placeholder: "${variable.placeholder}"`);
    console.log('');
  });
  
  console.log(`\nTotal variables found: ${extractedVariables.length}`);
  console.log('Variable names:', extractedVariables.map(v => v.name));
  
  // Test with mixed database JSON (simulating current mismatch issue)
  const mockDatabaseJson = {
    "BUDGET": { "type": "text", "label": "Budget", "required": true },
    "OUTCOMES": { "type": "text", "label": "Outcomes", "required": true },
    "TIMELINE": { "type": "text", "label": "Timeline", "required": true }
  };
  
  console.log('\n=== TESTING WITH DATABASE JSON MISMATCH ===');
  const mergedVariables = PromptDataAdapter.parseVariables(mockDatabaseJson, testPromptContent);
  
  console.log('Content variables vs Database variables:');
  console.log('Content found:', extractedVariables.map(v => v.name));
  console.log('Database has:', Object.keys(mockDatabaseJson));
  console.log('Merged result:', mergedVariables.map(v => v.name));
  
  return {
    contentVariables: extractedVariables,
    mergedVariables,
    success: extractedVariables.length > 0
  };
}

// Export for manual testing
if (typeof window !== 'undefined') {
  (window as any).testVariableExtraction = testVariableExtraction;
  console.log('🧪 Variable extraction test available: window.testVariableExtraction()');
}